/**
 * Is this a phone, the kind that can place a call and save a contact?
 *
 * Asked of the browser itself, not the screen: a laptop with a touch screen, or a laptop
 * window made narrow, is still a computer. Phone browsers say so: Android's mark themselves
 * as mobile, iPhones name themselves. Tablets count as computers (no cell calls).
 * A phone set to "Request desktop site" counts as a computer, which is what that asks for.
 */
function detect(): boolean {
  const nav = navigator as Navigator & { userAgentData?: { mobile?: boolean } };
  if (nav.userAgentData?.mobile === true) return true;
  return /iPhone|iPod|Android.+Mobile|Windows Phone|Mobile.+Firefox|Opera Mini/i.test(nav.userAgent);
}

export const IS_PHONE = detect();

/** Copy text, also where the clipboard API is missing (a laptop on http://192.168...). */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the old way
  }
  const box = document.createElement('textarea');
  box.value = text;
  box.setAttribute('readonly', '');
  box.style.position = 'fixed';
  box.style.opacity = '0';
  document.body.appendChild(box);
  box.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  box.remove();
  return ok;
}
